// extracted by mini-css-extract-plugin
export var snappySlider = "style-module--snappySlider--6167a";